(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-store-locator"]) return;
  try {
    

  !(function() {
    ("use strict");

    class MyStoreLocator extends HTMLElement {

      constructor() {
        super();
        this.container = this.querySelector(".store-locator__wrapper")
        this.tabs = this.querySelectorAll(".store__tab")
        this.cards = this.querySelectorAll(".store")
      }

      connectedCallback() {
        this.handleUrlParams();
        this.handleEvents();
      }

      handleElements(elements, activeEl) {
        elements.forEach(el => {
          el.classList.remove('active');
          el.dataset.region == activeEl && el.classList.add('active');
        });
      }

      handleUrlParams() {
        const url = new URL(window.location.href);
        const region = url.searchParams.get('region');
        if (region) {
          this.handleElements(this.tabs, region);
          this.handleElements(this.cards, region);
        }
        this.container.classList.remove('hidden');
      };

      handleEvents() {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', (e) => {

            const currentRegion = e.target.innerHTML;

            const url = new URL(window.location.href);
            url.searchParams.set('region', currentRegion);
            window.history.pushState({}, '', url);

            this.handleElements(this.tabs, currentRegion);
            this.handleElements(this.cards, currentRegion);
          });
        });
      }
    }

    customElements.define("store-locator", MyStoreLocator);
  })();

  } catch(e) { console.error(e); }
})();
})();
